"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RESET_STATE = exports.GET_RECOMMENDATIONS = exports.RecommendationsType = exports.RecommendationsTagKey = void 0;
var RecommendationsType;
(function (RecommendationsType) {
    RecommendationsType["ACTIVITY"] = "ACTIVITY";
    RecommendationsType["REWARD"] = "REWARD";
    RecommendationsType["PROMOTION"] = "PROMOTION";
    RecommendationsType["DEEP_LINK"] = "DEEP_LINK";
})(RecommendationsType || (exports.RecommendationsType = RecommendationsType = {}));
var RecommendationsTagKey;
(function (RecommendationsTagKey) {
    RecommendationsTagKey["MOBILE_FEATURED"] = "MOBILE_FEATURED";
    RecommendationsTagKey["WEB_FEATURED"] = "WEB_FEATURED";
})(RecommendationsTagKey || (exports.RecommendationsTagKey = RecommendationsTagKey = {}));
const GET_RECOMMENDATIONS = 'recommendations/GET_RECOMMENDATIONS';
exports.GET_RECOMMENDATIONS = GET_RECOMMENDATIONS;
const RESET_STATE = 'recommend/RESET_STATE';
exports.RESET_STATE = RESET_STATE;
//# sourceMappingURL=types.js.map